import axios from 'axios';
import { APISettings } from '../../config/ApiSettings';

const baseUrl = new APISettings().getApiURL();

class AuthAPI {
  public validateUser: (accessToken: string) => Promise<any> = async (accessToken: string) => {
    return (await axios.post(`${baseUrl}/auth/ValidateUser/${accessToken}`)).data.output;
  };
}

export const authAPI = new AuthAPI();
